// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3WkXT","header":"PatientBlock_header__1gTSP","label":"PatientBlock_label__3j_F-","option":"PatientBlock_option__2ib62"};